import { render, staticRenderFns } from "./myQuota.vue?vue&type=template&id=2ad64630&scoped=true&"
import script from "./myQuota.vue?vue&type=script&lang=js&"
export * from "./myQuota.vue?vue&type=script&lang=js&"
import style0 from "./myQuota.vue?vue&type=style&index=0&id=2ad64630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad64630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ad64630')) {
      api.createRecord('2ad64630', component.options)
    } else {
      api.reload('2ad64630', component.options)
    }
    module.hot.accept("./myQuota.vue?vue&type=template&id=2ad64630&scoped=true&", function () {
      api.rerender('2ad64630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/quota/myQuota.vue"
export default component.exports